import React from 'react';
import { Card, Form, InputGroup } from 'react-bootstrap';
import { ToolCardProps } from '../types/types';

const ToolCard: React.FC<ToolCardProps> = ({
  title,
  toolType,
  toolData,
  cardClass,
  handleToolChange
}) => {
  return (
    <Card className={`tool-card ${cardClass}`}>
      <Card.Body>
        <h3>{title}</h3>
        <Form.Group className="mb-3" controlId={`${toolType}Hours`}>
          <Form.Label>Running Hours</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter running hours"
            value={toolData.hours}
            onChange={e => handleToolChange(toolType, 'hours', e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId={`${toolType}Cost`}>
          <Form.Label>Tool Costs (USD)</Form.Label>
          <InputGroup>
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              step="0.01"
              placeholder="Enter tool cost"
              value={toolData.cost}
              onChange={e => handleToolChange(toolType, 'cost', e.target.value)}
              required
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3" controlId={`${toolType}CapROP`}>
          <Form.Label>Cap ROP (Feet/hour)</Form.Label>
          <Form.Control
            type="number"
            step="0.1"
            placeholder="Enter Cap ROP"
            value={toolData.capROP}
            onChange={e => handleToolChange(toolType, 'capROP', e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId={`${toolType}SaltROP`}>
          <Form.Label>Salt ROP (Feet/hour)</Form.Label>
          <Form.Control
            type="number"
            step="0.1"
            placeholder="Enter Salt ROP"
            value={toolData.saltROP}
            onChange={e =>
              handleToolChange(toolType, 'saltROP', e.target.value)
            }
            required
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default ToolCard;
